import React, { useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./Css/AuthorCommonPage.module.css";
import { useAuthor } from "../../../hooks/useAuthors";
import Loading from '../../../common/HousGlass Loader/Loading';
import { toast } from 'react-toastify';
import { useFollowActions, useFollowStatus } from "../../../hooks/useFollowersHooks";
import UserSeries from "./UserSeries";

const AuthorProfile = () => {
  const { id } = useParams();
  const [showImagePreview, setShowImagePreview] = useState(false);

  // Fetch author data using our custom hook
  const { author, isLoading: authorLoading, error: authorError } = useAuthor(id);
  
  // Fetch follow status
  const { 
    data: followStatus, 
    isLoading: statusLoading 
  } = useFollowStatus(author?.user_id);
  
  // Get follow actions
  const { 
    followUser, 
    unfollowUser, 
    isFollowLoading, 
    isUnfollowLoading 
  } = useFollowActions();
  
  
  // Get follow counts


  const isLoading = authorLoading || statusLoading || isFollowLoading || isUnfollowLoading;
  const isFollowing = followStatus?.isFollowing;

  const handleFollowClick = () => {
    if (isFollowing) {
      unfollowUser(author?.user_id, {
        onError: (error) => {
          toast.error(error?.response?.data?.message || "Failed to unfollow author");
        }
      });
    } else {
      followUser(author?.user_id, {
        onError: (error) => {
          toast.error(error?.response?.data?.message || "Failed to follow author");
        }
      });
    }
  };

  if (authorLoading || isLoading) {
    return <div className={styles.loading}><Loading/></div>;
  }

  if (authorError) {
    return <div className={styles.error}>Failed to load author profile</div>;
  }

  if (!author) {
    return <div className={styles.notFound}>No author found</div>;
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.detailContainer}>
        {/* Cover Image Section */}
        <div className={styles.coverImageContainer}>
          <div
            className={styles.coverImage}
            style={{ backgroundImage: `url(${author.banner_image})` }}
          />
        </div>

        {/* Profile Section */}
        <div className={styles.profileSection}>
          {/* Left side with profile image */}
          <div className={styles.profileLeft}>
            <div
              className={styles.profileImageWrapper}
              onClick={() => setShowImagePreview(true)}
              role="button"
              tabIndex={0}
            >
              <img
                src={author.profile_image}
                alt={author.name}
                className={styles.profileImage}
              />
            </div>
          </div>
          
          {/* Right side with author information */}
          <div className={styles.profileRight}>
            <div className={styles.nameSection}>
              <h2 className={styles.authorName}>{author.name}</h2>
              <button
                className={`${styles.followButton} ${
                  isFollowing ? styles.following : styles.notFollowing
                }`}
                onClick={handleFollowClick}
                disabled={isFollowLoading || isUnfollowLoading}
              >
                {isFollowLoading || isUnfollowLoading ? (
                  "Loading..."
                ) : isFollowing ? (
                  "Following"
                ) : (
                  "Follow"
                )}
              </button>
            </div>
            <p className={styles.authorBio}>{author.bio}</p>
            <div className={styles.additionalInfo}>
              {author.additionalInfo && (
                <>
                  <p className={styles.books}>Books Published: {author.additionalInfo.booksPublished}</p>
                </>
              )}
              {author.additionalInfo && (
                <p className={styles.rating}>Rating: {author.additionalInfo.rating}/5</p>
              )}
            </div>   
          </div>
        </div>
        <UserSeries id={author?.user_id}/>
      </div>

      {/* Image Preview Modal */}
      {showImagePreview && (
        <div
          className={styles.modalOverlay}
          onClick={() => setShowImagePreview(false)}
        >
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={styles.closeButton}
              onClick={() => setShowImagePreview(false)}
            >
              ×
            </button>
            <img
              src={author.profile_image}
              alt={author.name}
              className={styles.previewImage}
            />
          </div>
        </div>
      )}
      
    </div>
  );
};

export default AuthorProfile;